/**
 * .tuMetrics {"tu1": 0.98, "tu2": 0.98, "tu3": 1, "notes": "Pure 4-digit backplane code shape", "tuVersion": "2.5"}
 * .help "Exactly four digits — shared by the privacy latch UI and RPC clients without loading supabase."
 */
export function isFourDigitCode(value: string): boolean {
  return /^\d{4}$/.test(value);
}
